import { Menu, MenuProps } from 'antd';
import classNames from 'classnames';
import React, { FC, memo, PropsWithChildren, ReactNode } from 'react';
import s from './index.module.scss';

interface Tab {
  key: string;
  label: string;
  icon?: ReactNode;
}

interface TabSwitcherProps extends PropsWithChildren {
  tabs: Tab[];
  selectedTabKey: string;
  onChangeTab: (tab: string) => void;
  className?: string;
  /** Rendered before the tab bar on the same row (left). */
  title?: ReactNode;
}

export const TabSwitcher: FC<TabSwitcherProps> = memo((props) => {
  const { tabs, selectedTabKey, children, onChangeTab, className, title } = props;

  const menuItems: MenuProps['items'] = tabs.map(({ label, icon, key }) => ({ label, key, icon }));

  const handleChangeTab = ({ key }: { key: string }): void => {
    onChangeTab(key);
  };

  const menu = <Menu className={s.menu} mode="horizontal" items={menuItems} selectedKeys={[selectedTabKey]} onSelect={handleChangeTab} />;

  return (
    <div className={classNames('flex flex-col', className)}>
      <div className={classNames('mb-7', s.tabBar)}>
        {title ? (
          <div className={s.tabBarContent}>
            <div className={s.title}>{title}</div>
            <div className={s.menuSlot}>{menu}</div>
          </div>
        ) : (
          menu
        )}
      </div>
      <>{children}</>
    </div>
  );
});
